module.exports = __webpack_public_path__ + "static/media/02_1.00b26ab7.gif";